import {inject, injectable} from "inversify";
import {makeAutoObservable} from "mobx";
import {NFL_ACCOUNT_URL} from "data/constants";
import {Bindings} from "data/constants/bindings";
import {ViewController} from "data/types/structure";
import type {ILocalizationStore} from "data/stores/localization/localization.store";

export interface INflAccountController extends ViewController {
	readonly i18n: ILocalizationStore;
	get link(): string;
}

@injectable()
export class NflAccountController implements INflAccountController {
	constructor(@inject(Bindings.LocalizationStore) public readonly i18n: ILocalizationStore) {
		makeAutoObservable(this);
	}

	get link() {
		return NFL_ACCOUNT_URL ? `${NFL_ACCOUNT_URL}?redirectUrl=${window.location.href}` : "";
	}
}
